import { render, staticRenderFns } from "./DefaultFilterPc.vue?vue&type=template&id=3374d2a1&"
import script from "./DefaultFilterPc.vue?vue&type=script&lang=js&"
export * from "./DefaultFilterPc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports